









import { Component, Prop, Mixins } from "vue-property-decorator";
import { LinkMixin } from "@/mixins/LinkMixin";

@Component
export default class IconItem extends Mixins(LinkMixin) {
  @Prop({
    required: true,
  })
  icon: string;

  @Prop({
    default: "black",
  })
  iconColor: string;

  @Prop({
    required: true,
  })
  text: string;

  @Prop({
    default: "4",
  })
  margin: string;

  @Prop({
    default: "",
  })
  link: string;
}
